import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

import {
  PrivacyPolicy,
  TsAndCs,
  IStrapiDocument,
} from 'src/app/interfaces/strapi';

import StrapiService from 'src/app/services/strapi.service';
import { NgIf, NgFor } from '@angular/common';
import { RenderMarkdownComponent } from '../../../shared/components/render-markdown/render-markdown.component';

@Component({
    selector: 'app-reg-modal',
    templateUrl: './reg-modal.component.html',
    styleUrls: ['./reg-modal.component.scss'],
    imports: [
        NgIf,
        RenderMarkdownComponent,
        NgFor,
    ],
})
export class RegModalComponent implements OnInit {
  @Input() public type = '';

  @Input() public show = false;

  @Input() public uniListModal = false;

  @Output() private readonly showChange = new EventEmitter<boolean>();

  @Output() private readonly acceptedChange = new EventEmitter<boolean>();

  public tc: TsAndCs = <TsAndCs>{};

  public pc: PrivacyPolicy = <PrivacyPolicy>{};

  public enableAccept = false;

  constructor(public readonly strapi: StrapiService) {}

  ngOnInit(): void {
    if (this.type === 'tc') {
      this.strapi
        .getDocumentsByType('terms-and-condition', {
          populate: {
            banner: {
              populate: {
                slides: { populate: ['image'] },
              },
            },
          },
        })
        .subscribe((data: IStrapiDocument<TsAndCs>) => {
          this.tc.title = String(data.data.attributes.title);
          this.tc.markdown = data.data.attributes.markdown;
        });
    }
    if (this.type === 'pc') {
      this.strapi
        .getDocumentByUID('privacy-policy', 'privacy-notice', {
          populate: {
            policies: { populate: '*' },
            banner: {
              populate: {
                slides: { populate: ['image'] },
              },
            },
          },
        })
        .subscribe({
          next: (data: IStrapiDocument<PrivacyPolicy>) => {
            this.pc.title = String(data.data.attributes.title);
            this.pc.policies = data.data.attributes.policies;
          },
        });
      this.enableAccept = true;
    }
  }

  public accept() {
    this.acceptedChange.emit(true);
    this.showChange.emit(false);
  }

  public decline() {
    this.acceptedChange.emit(false);
    this.showChange.emit(false);
  }

  public handleScroll($event: Event): void {
    const target = <HTMLElement>$event.target;
    // take off a little (10px) to account for any rounding or other accuracy issues
    if (target.offsetHeight + target.scrollTop >= target.scrollHeight - 10) {
      this.enableAccept = true;
    }
  }
}
